
import React from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface TranscriptDisplayProps {
  transcript: string;
  response: string;
}

const TranscriptDisplay: React.FC<TranscriptDisplayProps> = ({ transcript, response }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className={`space-y-3 w-full ${isMobile ? 'text-sm' : ''} mt-4`}>
      {transcript && (
        <div className="p-3 bg-secondary rounded-lg">
          <p className={`${isMobile ? 'text-xs' : 'text-sm'} text-gray-700`}>{transcript}</p>
        </div>
      )}
      {response && (
        <div className="p-3 bg-primary/10 rounded-lg">
          <p className={`${isMobile ? 'text-xs' : 'text-sm'} text-gray-700 whitespace-pre-wrap`}>{response}</p>
        </div>
      )}
    </div>
  );
};

export default TranscriptDisplay;
